module.exports = __webpack_public_path__ + "static/media/summary.ee05c4b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/summary.svg
// module id = 1655
// module chunks = 0